import Seller_speak_icon from './images/Seller_speak_icon.svg';

export const TROPHY_GIF_PATH = Seller_speak_icon;
export const SOURCE_COMPONENT = 'sellers_who_speak';
export const BASE_KEY = 'search_perseus.recommendations.sellers_who_speak';
